<template>
  <div class="workbench-container h-100">
    <div v-if="someone.name" class="customer-current" style="text-align: center;">
      <div class="left">以下均为与
        <span>{{ someone.name }}</span>
        <span v-if="someone.organization_name">{{ someone.organization_name }}</span>
        &nbsp;&nbsp;相关的订单
      </div>
      <div class="right">
        <div @click="handelQueryMine">查看我的</div>
      </div>
    </div>

    <search-form v-show="boolSearch" :query-params.sync="searchCondition" fix-more-query class="search-form"
                 :configs="MapSearchConfigs"
                 @handleQuery="refresh"/>
    <div class="header">
      <div class="left">
        <el-radio-group v-model="searchCondition.by_the_user.rule" size="mini">
          <el-radio-button v-for="(item,key) in MapByMe" :key="key" :label="key">
            {{ getTabName(item) }}
          </el-radio-button>
        </el-radio-group>
        <template>
          <!--     申请开票     -->
          <apply-invoice-opt v-if="searchCondition.by_the_user.rule==='SALE'" :data-list="ordersSelected"
                             class="btn btn-apply-invoice" @applied="refresh"/>
          <el-button v-if="userAuth.can_set_team" :disabled="ordersSelected.length===0"
                     @click="boolDistributeOri=true"
                     class="btn" size="mini" style="margin-left: 10px;">
            分配小组
          </el-button>
        </template>
      </div>
      <div class="right">
        <!--    时间区间描述    -->
        <span v-if="LabelTimeRange" class="desc">{{ LabelTimeRange }}</span>
        <!-- 查询 -->
        <el-tooltip class="item" effect="dark" content="显隐查询" placement="top-start">
          <el-button icon="el-icon-search" circle size="mini" @click="boolSearch=!boolSearch"/>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="刷新列表" placement="top-start">
          <el-button icon="el-icon-refresh" circle size="mini" @click="refresh" style="margin:0 4px;"/>
        </el-tooltip>
        <!-- 显示列 -->
        <el-tooltip class="item" effect="dark" content="设置表格" placement="top-start">
          <set-tbl-columns @success="$refs['refTableAdOrder'].getTableThead()" circle style="margin-left: 0"/>
        </el-tooltip>
      </div>
    </div>
    <div>

    </div>
    <template>
      <template v-if="searchCondition.by_the_user.rule==='MY_CUSTOMER_ALL'">
        <div v-if="searchQueryCustomerWait" class="customer">
          <div>
            <div style="margin-bottom: 10px; font-size: 24px; font-weight: bold;">客户订单</div>
            <div style="margin-bottom: 30px;color: #8a8e99">输入名称选择客户，查看该客户下所有订单。</div>
            <div style="margin-bottom: 50%">
              <el-select v-model="searchCondition.by_the_user.customer_id" filterable default-first-option
                         remote
                         :remote-method="handelRemoteCustomer" style="width: 500px"
                         placeholder="请选择客户">
                <el-option v-for="item in optionsCustomers" :key="item.customer_id"
                           :label="item.customer_name"
                           :value="item.customer_id"/>
              </el-select>
              <el-button icon="el-icon-search" @click="handelSearchCustomer"/>
            </div>
          </div>
        </div>
        <div v-else class="customer-current">
          <div class="left">当前客户：<span>{{ theCustomerName }}</span></div>
          <div class="right">
            <div @click="handelSearchCustomerClear">查看其他客户订单</div>
          </div>
        </div>
      </template>
      <ad-order-table
          :key="searchCondition.by_the_user.rule"
          ref="refTableAdOrder"
          v-show="searchCondition.by_the_user.rule!=='MY_CUSTOMER_ALL'||(searchCondition.by_the_user.rule==='MY_CUSTOMER_ALL'&&!searchQueryCustomerWait)"
          :query-params.sync="searchCondition"
          :selected-data.sync="ordersSelected"
          :readonly="searchCondition.by_the_user.rule==='MY_CUSTOMER_ALL'"
          @handleSelectionChange="handleSelectionChange"
          @refreshOrderList="refresh"
          @goDetail="goDetail"
      />
    </template>

    <distribute-organization :show.sync="boolDistributeOri" :orders="ordersSelected" @success="refresh"/>
  </div>
</template>

<script>
import AdOrderTable from "@/views/adOrder/components/AdOrderTable.vue";
import SearchForm from "@/views/adOrder/order/components/SearchForm.vue";
import ApplyInvoiceOpt from "@/views/adOrder/components/ApplyInvoiceOpt.vue";
import DistributeOrganization from "@/views/adOrder/components/DistributeOrganization.vue";
import {searchSelectOptions as MapSearchOptions} from "@/views/adOrder";
import {optionsSaleCustomers} from "@/api/customers";
import {boolTeamLeader} from "@/utils/auth";
import SetTblColumns from "../../adOrder/components/SetTblColumns.vue";

const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).value : {id: -1}
const user_id = user.id

const MapByMe = {
  ALL: '全部',
  SALE: `我销售的`,
  EXEC: `我执行的`,
  CREATE: `我创建的`,
  MEDIUM: `媒介是我`,
  MY_CUSTOMER_ALL: `我客户的订单`,
  EXEC_NO_PAY: `已执行未回款`,
  // MY_TEAM: `我组的`,
}
if (boolTeamLeader()) {
  MapByMe.MY_TEAM = `我组的`
}
const MapSearchConfigs = [
  'customer_id', 'artist_id', 'time_type', 'bool_exec',
  'executor_id', 'pay_status', 'invoice_status', 'is_can_invoice', 'brand', 'order_no',
  'platform', 'order_type', 'bool_undo', 'organization_id'
];
const ModelSearchCondition = {
  by_the_user: {rule: 'ALL', customer_id: null, user_id},
  time_type: 'created_timestamp',
  timeRange: [],
  orderBy: '`id` desc',
  agent_name: null,
  brand: null,
  company_id: null,
  form_of_cooperation: null,
  order_type: null,
  bool_undo: 0,
  contract_no: null,
  contract_filed: null,
  customer_id: [],
  order_no: [],
  order_nos: '',
  is_lb: [],
  is_trailer: [],
  pay_status: [],
  invoice_status: [],
  sale_id: [],
  executor_id: [],
  creator_id: [],
  platform: [],
  order_source: [],
  artist_id: [],
  organization_id: [],
  bool_exec: [],
  is_mark_invoiced: null,
  is_mark_rebate: null,
  is_can_invoice: null,
}
export default {
  name: "index",
  components: {SetTblColumns, DistributeOrganization, ApplyInvoiceOpt, AdOrderTable, SearchForm},
  data() {
    return {
      MapByMe,
      MapSearchConfigs,
      MapSearchOptions,
      boolSearch: false,
      boolDistributeOri: false,
      searchQueryCustomerWait: true,
      theCustomerName: null,
      optionsCustomers: [],
      ordersSelected: [],
      searchCondition: {...{}, ...ModelSearchCondition},
      someone: {id: null, name: null, organization_name: null}
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    LabelTimeRange() {
      const _this = this
      const obj = MapSearchOptions.datetimeOptions.find(_ => _.value === _this.searchCondition.time_type)
      const timeRange = _this.searchCondition.timeRange
      if (!obj || !Array.isArray(timeRange) || !timeRange.length) {
        return false
      }
      const date = timeRange.join('~')
      return obj.label + '：' + date
    },
  },
  watch: {
    "$route.query": {
      handler() {
        this.setSomeone()
      },
      deep: true
    }
  },
  mounted() {
    this.setSomeone()
  },
  methods: {
    setSomeone() {
      const {id, name, organization_name} = this.$route.query
      this.someone = {id, name, organization_name}
      if (id) {
        this.searchCondition.by_the_user.user_id = id
      } else {
        this.searchCondition.by_the_user.user_id = user_id
      }
    },
    handelQueryMine() {
      this.$router.push({name: 'SomeoneOrders'})
    },
    /**
     * 替换tab名称
     * @param name
     * @returns {*}
     */
    getTabName(name) {
      let {sex} = this.$route.query
      sex = sex || '我'
      return name.replace("我", sex)
    },
    handleSelectionChange(val) {
      this.ordersSelected = val
    },
    clearData() {
      this.ordersSelected = []
      this.$refs['refTableAdOrder'].handleClearSelection()
    },
    refresh() {
      this.clearData()
      this.getOrdersList()
    },
    //加载订单列表
    getOrdersList() {
      this.$refs['refTableAdOrder'].initList()
    },
    goDetail({id}) {
      const {href} = this.$router.resolve({
        name: 'editAdOrder',
        params: {id: id},
      });
      window.open(href, "_blank");
    },
    handelSearchCustomer() {
      const _this = this
      const obj = _this.optionsCustomers.find(_ => _.customer_id === _this.searchCondition.by_the_user.customer_id)
      if (!obj) {
        this.$message.warning('请选择客户')
        this.searchQueryCustomerWait = true
        return
      }
      _this.theCustomerName = obj.customer_name
      this.refresh()
      _this.searchQueryCustomerWait = false
    },
    handelSearchCustomerClear() {
      this.searchQueryCustomerWait = true
      this.searchCondition.by_the_user.customer_id = null;
      this.refresh()
    },
    async handelRemoteCustomer(query) {
      const response = await optionsSaleCustomers({customer_name: query, sale_id: this.someone.id || user_id})
      this.optionsCustomers = response.model || []
    }
  }
}
</script>

<style lang="scss">
.workbench-container {
  padding: 12px;

  .header {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;
    }

    .right {
      display: flex;
      align-items: center;

      .el-button + .el-button {
        margin-left: 0;
      }

      .desc {
        margin-right: 8px;
        color: #8a8e99;
        font-size: 12px;
      }

    }
  }

  .search-form {
    border: 1px solid rgb(242, 242, 242);
    border-radius: 20px;
    padding: 10px 20px;
    margin-bottom: 16px;

    .handel.el-form-item {
      .el-form-item__content {
        text-align: center;
      }
    }
  }

  .btn {
    border-radius: 4px;

    button {
      border-radius: 4px;
    }
  }

  .btn-apply-invoice {
    margin-left: 10px;

    .el-button {
      margin-right: 0 !important;
    }
  }

  .customer {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 1px solid #f2f2f2;
    border-radius: 10px;
    height: calc(100% - 38px);
  }

  .customer-current {
    height: 50px;
    background: #feeff4;
    border-radius: 6px 6px 0 0;
    margin-bottom: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      font-size: 14px;
      display: flex;
      align-items: flex-end;

      span {
        margin-left: 10px;
        font-size: 19px;
        font-weight: 700;
        line-height: 21px;
      }
    }

    .right {
      div {
        width: 120px;
        height: 32px;
        background: #fff;
        border-radius: 20px;
        line-height: 32px;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>
